<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CUsUNx/tc-custom/9781526774118.jpg?1709205916527" alt="This image is the cover for the book Leopard 2, TankCraft"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Leopard 2, TankCraft
      </h1>
      <p class="bookDescription body article font2">
        <b>A modeler’s guide to one of the most powerful tanks operating today: “Highly recommended.” —<i>AMPS Indianapolis</i></b><br/><br/>When the Leopard 2, a third-generation main battle tank, first entered service with the Bundeswehr in 1979, at the height of the Cold War, it was indisputably the most advanced and potent tank in the world. Over four decades it has undergone numerous upgrades and modifications to ensure it remains one of the most powerful tanks operating today. It currently serves with the armies of seventeen nations, from Canada to Turkey and many European states.<br/><br/>The Leopard 2 is also a popular subject for modelers, which is why David Grummitt’s highly illustrated expert guide is so valuable. As well as describing in detail the Leopard 2’s design, development, and combat history, he gives a full account of the wide range of modeling kits and accessories available in all the popular scales. Included is a modeling gallery, which features six builds covering a range of Leopard 2s serving with different nations and a section of large-scale color profiles which provide both reference and inspiration for modelers and military enthusiasts alike.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Grummitt
      </h2>
      
      <p class="authorDescription body article">David Grummitt is editor of Military Modelcraft International with more than a decade of building models and writing articles for publication. As well as being editor of MMI since 2009, he is a professional historian who has written several books on fifteenth- and sixteenth-century military and political history</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1dc42f4d